class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Ensure Esc key and overlay click close the drawer
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  // Accessibility for cart icon
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // Open the drawer and trap focus
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

     // Make overlay visible when opening the drawer
     this.style.visibility = 'visible';
     const overlay = this.querySelector('#CartDrawer-Overlay');
     if (overlay) {
       overlay.style.display = 'block';
       overlay.style.visibility = 'visible';
     }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const focusContainer = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(focusContainer, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  // Close the drawer and remove overlay
  close() {
    // Remove 'active' class to trigger close animations
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden'); // Re-enable page scrolling
  
    // Hide the overlay
    const overlay = document.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.style.visibility = 'hidden';
    }
  
    // Ensure the cart drawer's visibility is hidden
    this.style.visibility = 'hidden';
  }

  // Render cart contents
renderContents(parsedState) {
  this.productId = parsedState.id;

  // Update sections
  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!sectionElement) return;
    sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
  });

  // Toggle is-empty class depending on cart contents
  const isNowEmpty = !parsedState.item_count || parsedState.item_count === 0;
  this.classList.toggle('is-empty', isNowEmpty);

  setTimeout(() => {
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.open();

    // Dispatch custom event to update "In Basket" counts
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if (typeof window.updateBasketCounts === 'function') window.updateBasketCounts();


  });
}


  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  // Override updateQuantity to refresh "In Basket" counts when quantity changes in drawer
  updateQuantity(line, quantity, name, variantId) {
    super.updateQuantity(line, quantity, name, variantId);

    // Trigger basket count update after quantity update
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
